export default __webpack_public_path__ + "static/media/live3.883ac81f.jpeg";